<script>

export default {
    template: '#project-list-loop-container2',
    name: "HomeProjects",
    components: {},
    props: {
        projects: [],
        projectsbackend: [],
    },
    data: () => ({
    }),
    mounted() {
    },
    methods: {
    }
};
</script>

<style>
.background-assets {
    height: 14rem;
    background-image: url("../../assets/images/pages/error.svg");
    background-size: contain;
    background-position: center;
}

.text-font {
    font-size: 1.2rem;
}

.select-order {
    padding-left: 0;
}

.property-card-col {
    margin-bottom: 1rem;
}

.quantity-project-div {
    padding-right: 0;
    margin-right: -24px;
    justify-content: end;
}

.vs__dropdown-toggle {
    border: 1px solid #ddd;
}

.active {
    border-color: #de1f69 !important;
    color: #de1f69 !important;
}

.pink-text {
    color: #de1f69 !important;
}

.li-pink-disable:hover {
    color: #de1f69 !important;
    border-color: #de1f69 !important;
}

.post-nav {
    padding-bottom: 0rem;
}

.sidebar-content-right {
    margin-bottom: 0;
}

.card-preaprobation {
    background-color: #f5f5f5;
    padding: 1rem;
    padding-left: 2rem;
    padding-right: 2rem;
    border: 1px solid #d2d2d2;
    border-radius: 4px;
}

.align-center-content {
    display: flex !important;
    align-items: center;
}

@media (max-width: 1200px) {
    .sidebar-content-right {
        margin-top: 6rem;
    }

    .quantity-project-div {
        display: flex;
        justify-content: initial;
    }
}

@media (min-width: 1199px) and (max-width: 1615px) and (orientation: landscape) {
    .property-card-col {
        flex: 0 0 50%;
        max-width: 50%;
    }
}

@media (max-width: 575px) {
    .select-order {
        padding-left: 15px;
    }

    .background-assets {
        height: initial;
    }

    .text-font {
        font-size: 1rem;
    }
}
</style>
